
	var EdgeLengthComparator = function(){};
	EdgeLengthComparator.prototype.compare = function( edge1, edge2 ){
		return -parseInt( edge1.getLengthSquared()-edge2.getLengthSquared(), 10);
	};
	module.exports = EdgeLengthComparator;



//////////////////
// WEBPACK FOOTER
// ./node_modules/toxiclibsjs/geom/mesh/subdiv/EdgeLengthComparator.js
// module id = 4589
// module chunks = 15